import { render, staticRenderFns } from "./DeletePopover.vue?vue&type=template&id=d3d67062&scoped=true&"
import script from "./DeletePopover.vue?vue&type=script&lang=js&"
export * from "./DeletePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d67062",
  null
  
)

export default component.exports